import { globalStyles } from "shared/constants";

const style = {
  toastDialog: {
    '& .MuiDialog-paper': {
      minHeight: 340,
      width: 500,
      maxHeight: 420,
      alignItems: 'center',
    },
    '& .MuiDialogContent-root': {
      padding: '0px !important',
    }
  },
  successText: {
    color: 'rgb(0, 213, 146)',
  },
  closeIcon: {
    position: 'absolute',
    right: 12,
  },
  bgPrimary: {
    background: '#002fa7' 
  },
  colorError: {
    color: '#f44336',
  },
  fontRoboto: {
    fontFamily: 'Roboto',
  }
};
export default style;
